import psl from 'psl';

export const SITE_DOMAIN_HINT =
  'Enter the root domain only, like example.com. Do not include https://, pages, or subdomains.';

export const normalizeSiteDomain = (value = '') => String(value).trim().toLowerCase();

const classifySiteDomain = (value) => {
  const normalizedValue = normalizeSiteDomain(value);

  if (!normalizedValue || normalizedValue.endsWith('.')) {
    return 'invalid';
  }

  const parsed = psl.parse(normalizedValue);

  if (!parsed.domain) {
    return 'invalid';
  }

  if (parsed.subdomain) {
    return 'subdomain';
  }

  return 'root';
};

export const validateSiteDomain = ({ value, existingNames = [], currentValue = '' }) => {
  const normalizedValue = normalizeSiteDomain(value);
  const normalizedCurrentValue = normalizeSiteDomain(currentValue);
  const domainType = classifySiteDomain(normalizedValue);

  if (normalizedValue === '') {
    return {
      normalizedValue,
      message: 'Domain name cannot be empty.',
    };
  }

  if (
    normalizedValue !== normalizedCurrentValue &&
    existingNames.some((existingName) => normalizeSiteDomain(existingName) === normalizedValue)
  ) {
    return {
      normalizedValue,
      message: 'This domain name is already in use.',
    };
  }

  if (domainType === 'subdomain') {
    return {
      normalizedValue,
      message: 'Please type the domain only - no subdomain.',
    };
  }

  if (domainType === 'invalid') {
    return {
      normalizedValue,
      message: 'Please enter a valid domain (e.g., example.com).',
    };
  }

  return {
    normalizedValue,
    message: null,
  };
};
